const mobileNoticeButton = document.querySelector("#close-mobile-notice");

if (mobileNoticeButton) {
  mobileNoticeButton.addEventListener("click", (e) => {
    e.preventDefault();
    document.cookie = "mobile_notice_seen=true;path=/";
    document.querySelector("#mobile-notice").classList.add("hidden");
  });
}
